import React, { useState } from 'react';
import { styled } from 'linaria/react';
import t from '@jetshop/intl';

import { default as Breadcrumbs } from '@jetshop/ui/Breadcrumbs';
import getParentOrCanonicalRoute from '@jetshop/ui/Breadcrumbs/getParentsOrCanonicalRoute';
import BrandLink from './components/BrandLink/BrandLink';
import { useCustomFields } from './components/useCustomFields';
import Gallery from './components/Gallery/Gallery';
import { SVG } from '../../assets/SVG';
import { useProductVariants } from '@jetshop/core/hooks/useProductVariants';
import { useVariantFromUrl } from '@jetshop/core/hooks/useProductVariants/useVariantFromUrl';
import AddToCartForm from './components/AddToCart/AddToCartForm';
//import ProductMisc from './components/ProductMisc/ProductMisc';
import ProductInfo from './components/ProductInfo/ProductInfo';
import { theme } from '../Theme';
import { Above, Below } from '@jetshop/ui/Breakpoints';
import Image from '@jetshop/ui/Image';
import RelatedColors from './components/RelatedColors/RelatedColors';
import BrandProducts from './components/ProductRecommendations/BrandProducts.js';
import SimilarProducts from './components/ProductRecommendations/SimilarProducts';
import { useStockStatus } from '@jetshop/ui/Stock/StockStatusContainer';
import { usePriceDisplay } from '../../hooks/usePriceDisplay';

const OuterWrapper = styled('div')`
  background: white;
  display: block;
  position: relative;
  width: 100%;

  .products-wrapper {
    max-width: 52%;
    margin: auto;
    @media only screen and (max-width: 2000px) {
      max-width: 62%;
    }

    @media only screen and (max-width: 1605px) {
      max-width: 72%;
    }

    @media only screen and (max-width: 1375px) {
      max-width: 82%;
    }

    ${theme.below.xl} {
      max-width: 83%;
    }

    ${theme.below.xl} {
      max-width: 80%;
    }
  }
`;

const StyledBreadcrumbs = styled(Breadcrumbs)`
  background: transparent;
  padding: 10px 30px;
  margin: 0 !important;
  * {
    text-decoration: none;
  }
  ${theme.below.lg} {
    padding: 5px 10px;
  }
`;

const ProductUpper = styled('div')`
  width: 50%;
  margin: auto;
  /* background: #f8f7f5; */
  background: #f6f6f6;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 20px 20px 50px 20px;
  grid-gap: 20px;
  ${theme.below.lg} {
    display: block;
    /* padding: 0 0 20px 0; */
  }
  @media only screen and (max-width: 2000px) {
    width: 60%;
  }

  @media only screen and (max-width: 1605px) {
    width: 70%;
  }

  @media only screen and (max-width: 1375px) {
    width: 80%;
  }

  ${theme.below.xl} {
    width: 80%;
  }
`;
const ProductImages = styled('div')`
  flex: 2;
  min-width: 100px;
  max-width: calc(1400px - 490px);
`;

const ProductBuyArea = styled('div')`
  flex: 1;
  width: 100%;
  max-width: 450px;
  padding-left: 20px;
  padding-top: 8rem;
  @media screen and (max-width: 1200px) {
    padding-top: 6rem;
    
  }
  /* margin-top: 10rem; */
  ${theme.below.lg} {
    margin-top: 3rem;
    padding-left: 0;
  }
  /* ${theme.below.md} {
    margin-top: 0;
  }
  ${theme.below.sm} {
    margin-top: 3rem;
  } */

  .short-description {
    padding-top: 10px;
    max-width: 90%;
    color: #343741;
    font-size: 14px;
    font-weight: 100;
    line-height: 21px;
  }
  .brand {
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    padding-bottom: 10px;
  }
  .inner {
    flex: 1;
    /* padding: 20px; */
    border-radius: 3px;

    &.no-images {
      margin-bottom: 1rem;
    }
    .product-overtitles {
      display: flex;
      span,
      a {
        color: #282828;
        margin-right: 3px;
        text-decoration: none;
        text-transform: uppercase;
        font-size: 14px;
        font-weight: bold;
        letter-spacing: 1px;
      }
    }
    .product-titles {
      margin-bottom: 20px;
      ${theme.below.lg} {
        margin-bottom: 10px;
      }
      h1 {
        color: #282828;
        font-size: 28px;
        margin: 0;
        line-height: 1;
        margin-bottom: 3px;
        ${theme.below.lg} {
          font-size: 22px;
        }
      }
      h2 {
        color: #282828;
        font-size: 14px;
        margin: 0;
        line-height: 1;
      }
    }

    .product-shortdescription {
      font-size: 12px;
      line-height: 1.4;
      margin-bottom: 10px;
    }
  }

  ${theme.below.lg} {
    padding: 0 10px;
  }
`;

const ProductUspAreaWrapper = styled('div')`
  border-top: 1px solid #dbdfe0;
  border-bottom: 1px solid #dbdfe0;
  padding: 10px 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;

  .header {
    font-family: Outfit;
    font-size: 11px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 1.1px;
    text-transform: uppercase;
  }
  .text {
    color: var(--Grey, #8a8d8f);
    /* span */
    font-family: Outfit;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .product-usp-item {
    display: flex;
    align-items: center;
    margin: 0;
    & > div {
      display: flex;
      flex-direction: column;
    }
    .icon {
      margin-right: 5px;
      width: 20px;
    }
    .text {
      font-size: 12px;
      line-height: 1;
    }
  }
`;

const UspBlock = ({ product, variant }) => {
  console.log(product);
  const stock = useStockStatus(product, variant);
  return (
    <ProductUspAreaWrapper>
      {/* PRODUCT USP FROM CUSTOM FIELDS */}

      <div className="product-usp-item">
        <span className="icon">
          <SVG name="CheckCircle" />
        </span>
        <div>
          <span className="header">lagerstatus</span>
          <span className="text">{stock.text}</span>
        </div>
      </div>

      <div className="product-usp-item">
        <span className="icon">
          <SVG name="CheckCircle" />
        </span>
        <div>
          <span className="header">{t('Article number')}</span>
          <span className="text">{(variant || product)?.articleNumber}</span>
        </div>
      </div>

      {product?.barcode && (
        <div className="product-usp-item">
          <span className="icon">
            <SVG name="CheckCircle" />
          </span>
          <div>
            <span className="header">EAN-nummer</span>
            <span className="text">{(variant || product)?.barcode}</span>
          </div>
        </div>
      )}

      <div className="product-usp-item">
        <span className="icon">
          <SVG name="OpenBox" />
        </span>
        <div>
          <span className="header">Leverans</span>
          <span className="text">Leverans inom 1-3 arbetsdagar</span>
        </div>
      </div>
    </ProductUspAreaWrapper>
  );
};

const Product = ({ result: { data, loading }, product, partialProduct }) => {
  const { showPrice } = usePriceDisplay();

  // KEEP OPEN TABS AND ACCORDION STATE
  const [remoteOpenIndex, setRemoteOpenIndex] = useState(0);
  // GET INITIAL VARIANT FROM URL
  const initialVariant = useVariantFromUrl();
  // DEFINE VARIANTHANDLER TO USE PRODUCTVARIANTS
  const variantHandler = useProductVariants(product, {
    initialVariant,
    preselectCheapest: true
  });
  // GET SELECTED VARIANT
  const {
    selectedVariant: selectedVariation,
    getMissingOptions
  } = variantHandler;

  // GET PARENTS FOR BREADCRUMBS
  const parents = getParentOrCanonicalRoute(data?.route?.parents, product);

  // GET DATA FROM CUSTOMFIELDS
  const { USP1, USP2, USP3, Varumarke, ...rest } = useCustomFields(product);

  // FILTER OUT EMPTY USP
  const productUsps = [USP1?.value, USP2?.value, USP3?.value].filter(
    usp => usp
  );

  // console.log('product', product);
  // console.log('varumärke', Varumarke);

  return (
    <OuterWrapper>
      <StyledBreadcrumbs
        breadcrumbs={data?.route?.breadcrumbs || []}
        parents={parents}
      />
      <ProductUpper>
        {product?.images.length > 0 && (
          <ProductImages>
            <Gallery product={product} />
          </ProductImages>
        )}

        <ProductBuyArea>
          <div
            className={product?.images.lenght > 0 ? 'inner' : 'inner no-images'}
          >
            <div className="product-overtitles">
              {/* ändra tillbaka till varumärke */}
              {/* {Varumarke?.value || product?.subName ? (
                <BrandLink brand={Varumarke?.value || product?.subName} />
              ) : null} */}
              {/* <p className="brand"> </p> */}
            </div>
            <div className="product-titles">
              <h1>{product?.mainHeader || product?.name}</h1>

              <p className="short-description">{product?.shortDescription}</p>
            </div>

            {product && (
              <AddToCartForm
                product={product}
                variant={selectedVariation}
                getMissingOptions={getMissingOptions}
                variantHandler={variantHandler}
                showPrice={showPrice}
              />
            )}

            {/* INFO ABOUT STOCK ONLINE AND STORE, CAMPAIGNS, ONE DYNAMIC USP */}
            {/* <ProductMisc product={product} variant={selectedVariation} /> */}

            <div className="product-misc"></div>
            <UspBlock product={product} variant={selectedVariation} />

            {/* <Below breakpoint="lg">
              {matches =>
                matches && (
                  <RelatedColors mainProduct={product} title="Finns även som" />
                )
              }
            </Below> */}
          </div>
        </ProductBuyArea>
      </ProductUpper>

      {/* PRODUCT INFO, TABS DESKTOP, ACCORDION MOBILE */}
      <ProductInfo
        product={product}
        remoteOpenIndex={remoteOpenIndex}
        setRemoteOpenIndex={setRemoteOpenIndex}
      />
      <div className="products-wrapper">
        {(Varumarke?.value || product?.subName) && (
          <BrandProducts
            brand={Varumarke?.value || product?.subName}
            product={product}
          />
        )}
        {product?.canonicalCategory?.id && (
          <SimilarProducts product={product} />
        )}
      </div>
    </OuterWrapper>
  );
};

export default Product;
